import Auth0AuthUrls from './Auth0AuthUrls';
import ClassicCloudAuthUrls from './ClassicCloudAuthUrls';

export const LOCAL_STORAGE_AUTH_IDP_ITEM = 'ECW_LOCAL_STORAGE_AUTH_IDP';

export enum IdPType {
  CLASSIC_CLOUD,
  AUTH0,
}

/**
 * Implementations are utilities for building Auth URLs and Functions for a specific IdPType.
 */
export interface AuthUrls {
  getIdP(): string;
  getLoginUrl(): string;
  getLogoutUrl(): string;
  getTokenRefreshUrl(): string;
  getTokenRequestUrl(): string;

  /**
   * Clears the local storage authentication tokens, and forces a logout on the IdP.
   */
  logoutFunction(): void;

  /**
   * Returns whether the current IdP has changed since the last one used.  If they don't match, the invoker
   * should force a logout immediately.
   */
  idpHasChanged(): boolean;
}

/**
 * Factory for creating AuthUrls istances based on
 */
export const AuthUrlFactory = {
  create: (type: IdPType): AuthUrls => {
    let instance: AuthUrls;

    switch (type) {
      case IdPType.AUTH0:
        instance = new Auth0AuthUrls();
        break;
      default:
        instance = new ClassicCloudAuthUrls();
        break;
    }

    return instance;
  },
};
